import type { ReactNode } from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '../form';
import { DateInput, type DateInputProps } from '../date-input';
import { Text } from '@folio/components/ui/text';

export type FormDateInputProps<TFields extends FieldValues> = {
  control: Control<TFields>;
  label?: ReactNode;
  name: Path<TFields>;
  description?: ReactNode;
  required?: boolean;
} & DateInputProps;

export const FormDateInput = <TFields extends FieldValues>({
  control,
  label,
  name,
  description,
  required,
  ...props
}: FormDateInputProps<TFields>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem>
            {!!label && (
              <FormLabel fieldType="date">
                {label}{' '}
                {required && (
                  <Text inline tone="destructive">
                    *
                  </Text>
                )}
              </FormLabel>
            )}
            <FormControl>
              <DateInput value={field.value} onChange={field.onChange} {...props} />
            </FormControl>
            {!!description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
